import React from 'react';
import BaseSidebar from '../../../shared/components/layouts/BaseSidebar';

const AdminSidebar = ({ onSectionChange, activeSection }) => {
  const adminMenu = [
    'Analytics',
    'Manage Users',
    'Payments',
    'Manage Tiers',
    'Manage Tutorials',
  ];

  return (
    <BaseSidebar
      items={adminMenu}
      onSectionChange={onSectionChange}
      activeSection={activeSection}
      transformItemText={(text) => text.toLowerCase().replace(/\s+/g, '-')}
    />
  );
};

export default AdminSidebar;
